<template>
  <div
    class="text-input"
    :class="{ accepted: accepted, error: error, hasValue: hasValue }"
  >
    <span class="label">{{ placeholder }}</span>
    <div class="input-field">
      <input type="text" :value="modelValue" @input="updateValue" />
      <fa icon="check" class="checkmark" />
      <fa icon="exclamation" class="exclamation" />
    </div>
    <small class="error-msg">{{ errorMsg }}</small>
  </div>
</template>
<script>
export default {
  name: "text-field",
  props: {
    modelValue: String,
    placeholder: String,
    state: String,
  },
  computed: {
    accepted() {
      return this.state && this.state.startsWith("ACCEPTED");
    },
    error() {
      return this.state && this.state.startsWith("ERROR");
    },
    errorMsg() {
      return this.error && this.state.split("ERROR").pop();
    },
    hasValue() {
      return this.modelValue != null && this.modelValue.length > 0;
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>
